/**
 *
 * @param {number} timeout
 * @returns {Promise<boolean>}
 */
export const asyncTimeout = async (timeout = 100) => {
  // eslint-disable-next-line promise/param-names
  return await new Promise((res) =>
    setTimeout(() => {
      res(true)
    }, timeout)
  )
}
